import React, { useEffect, useState } from "react";
import { usePayment } from "../hooks";
import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextInput from "./inputs/TextInput";
import Section from "./section";
import { Controller, useFormContext } from "react-hook-form";
import { CustomerWallet } from "../models/Service";

const PhoneNumberInputs = ({
  isVertical = false,
  service,
}: {
  isVertical?: boolean;
  service: any;
}) => {
  const { t } = useTranslation();
  const {
    phoneNumber,
    setPhoneNumber,
    selectedMethod,
    customerUser,
    setSelectedWallet,
  } = usePayment();
  const customerWallet = customerUser?.customer_wallet_collection || [];

  const { control, watch } = useFormContext();

  const [phoneError, setPhoneError] = useState("");
  const wallet = watch("selectedWallet");

  useEffect(() => {
    if (wallet !== undefined) {
      setSelectedWallet(
        customerWallet.find(
          item => item.wallet_identifier === wallet
        ) as CustomerWallet
      );
    }
  }, [wallet]);

  const validatePhoneNumber = (value: string) => {
    if (!value)
      return t(
        "payment.phone.errors.required",
        "Le numéro de téléphone est requis"
      );
    if (!/^\d{9}$/.test(value))
      return t(
        "payment.phone.errors.format",
        "Le numéro doit contenir 9 chiffres"
      );
    return "";
  };

  const handlePhoneChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let phoneNumber = e.target.value;
    if (phoneNumber.startsWith("+237")) {
      phoneNumber = phoneNumber.replace("+237", "");
    }
    const value = phoneNumber.replace(/[^0-9]/g, "").slice(0, 9);
    setPhoneNumber(value);
    setPhoneError(validatePhoneNumber(value));
  };

  if (!selectedMethod) return null;

  const itemSizes = isVertical ? { xs: 12 } : { xs: 12, md: 6 };
  return (
    <Box mb={4}>
      <Grid
        container
        spacing={3}
        direction={isVertical ? "column" : "row"}
        alignItems={isVertical ? "stretch" : "flex-start"}
      >
        <Grid item {...itemSizes}>
          {service?.is_supporting_customer_wallets ? (
            <Section title={t("payment.paymentForSearch.step2_title")}>
              <Box>
                <Typography sx={{ fontSize: 11 }}>
                  {t("payment.paymentForSearch.wallet_intro")}
                </Typography>
                {customerWallet.length > 0 && (
                  <Controller
                    name="selectedWallet"
                    control={control}
                    rules={{ required: t("errors.field_required") }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        fullWidth
                        label={t(
                          "payment.paymentForSearch.select_wallet_label"
                        )}
                        sx={{ my: 2 }}
                        onChange={e => {
                          field.onChange(e);
                          handlePhoneChange(e);
                        }}
                      >
                        {[...customerWallet]
                          .sort(
                            (a, b) =>
                              (b.is_preferred ? 1 : 0) -
                              (a.is_preferred ? 1 : 0)
                          )
                          .map(wallet => (
                            <MenuItem
                              key={wallet.id}
                              value={wallet.wallet_identifier}
                            >
                              {wallet.wallet_identifier}
                              {wallet.is_preferred
                                ? ` (${t(
                                    "payment.paymentForSearch.preferred",
                                    "Preferred"
                                  )})`
                                : ""}
                            </MenuItem>
                          ))}
                      </TextField>
                    )}
                  />
                )}
              </Box>
            </Section>
          ) : (
            <>
              <TextInput
                fullWidth
                id="phoneNumber"
                label={t(
                  "payment.phone.label",
                  "Votre numéro de mobile money *"
                )}
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneChange}
                error={!!phoneError}
                helperText={phoneError}
                placeholder={t("payment.phone.placeholder", "Ex: 680156243")}
                variant="outlined"
              />
            </>
          )}
        </Grid>

      </Grid>
    </Box>
  );
};

export default PhoneNumberInputs;
